import { StackProps } from '@mui/material';
import { colorPaletteLight } from '@sb/cc-design-system';

import {
  CloseIconPointer,
  HiddenChipMeasureBox,
  HiddenChipMeasureStack,
  OverflowFilterChip,
  OverflowFilterChipList,
} from './OverflowFilterChips.styled';
import {
  IOverflowFilterChipItem,
  useOverflowFilterChips,
} from './useOverflowFilterChips';

interface IOverflowFilterChipsProps extends StackProps {
  items: IOverflowFilterChipItem[];
}

export const OverflowFilterChips = ({
  items,
  ...stackProps
}: IOverflowFilterChipsProps) => {
  const { hiddenItemCount, listRef, measureRef, overflowLabel, visibleItems } =
    useOverflowFilterChips({
      items,
    });

  if (items.length === 0) {
    return null;
  }

  return (
    <>
      <OverflowFilterChipList
        ref={listRef}
        direction="row"
        alignItems="center"
        {...stackProps}>
        {visibleItems.map((item) => (
          <OverflowFilterChip
            key={item.key}
            label={item.label}
            onEndIconClick={item.onRemove}
            endIcon={item.onRemove ? <CloseIconPointer /> : undefined}
            variant="filled"
            textColor={colorPaletteLight.secondary.info.deep}
          />
        ))}
        {hiddenItemCount > 0 && (
          <OverflowFilterChip
            label={overflowLabel}
            variant="filled"
            textColor={colorPaletteLight.secondary.info.deep}
          />
        )}
      </OverflowFilterChipList>
      <HiddenChipMeasureBox>
        <HiddenChipMeasureStack
          ref={measureRef}
          direction="row"
          alignItems="center">
          {items.map((item) => (
            <div key={`measure-${item.key}`} data-chip-width>
              <OverflowFilterChip
                label={item.label}
                endIcon={item.onRemove ? <CloseIconPointer /> : undefined}
                variant="filled"
                textColor={colorPaletteLight.secondary.info.deep}
              />
            </div>
          ))}
          <div data-overflow-chip>
            <OverflowFilterChip
              label={overflowLabel}
              variant="filled"
              textColor={colorPaletteLight.secondary.info.deep}
            />
          </div>
        </HiddenChipMeasureStack>
      </HiddenChipMeasureBox>
    </>
  );
};
